(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wrc-scrollcraft-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('wrc-route-hero')) {
    customElements.define('wrc-route-hero', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        this.stage = this.querySelector('.wrc-route-hero__stage');
        this.motionButton = this.querySelector('.wrc-route-hero__motion');
        this.motionButton.setAttribute('aria-pressed', 'false');
        this.motionButton.querySelector('[data-motion-label]').textContent = this.motionButton.dataset.pause;
        this.motionButton.querySelector('.wrc-route-hero__motion-mark').textContent = 'Ⅱ';
        this.frame = 0;
        this.visible = false;
        this.paused = false;
        this.media = window.matchMedia('(min-width: 1024px) and (prefers-reduced-motion: no-preference)');
        const signal = this.controller.signal;
        this.schedule = () => {
          if (this.frame || !this.active || !this.visible || this.paused) return;
          this.frame = requestAnimationFrame(() => { this.frame = 0; this.render(); });
        };
        this.configure = () => {
          this.active = this.dataset.motion === 'true' && this.dataset.editor !== 'true' && this.media.matches;
          this.dataset.active = String(this.active);
          this.motionButton.hidden = !this.active;
          if (!this.active) {
            cancelAnimationFrame(this.frame);
            this.frame = 0;
            this.style.setProperty('--wrc-progress', '0');
          } else { this.schedule(); }
        };
        this.media.addEventListener('change', this.configure, { signal });
        window.addEventListener('scroll', this.schedule, { passive: true, signal });
        window.addEventListener('resize', this.schedule, { passive: true, signal });
        this.motionButton.addEventListener('click', () => {
          this.paused = !this.paused;
          this.motionButton.setAttribute('aria-pressed', String(this.paused));
          this.motionButton.querySelector('[data-motion-label]').textContent = this.paused ? this.motionButton.dataset.resume : this.motionButton.dataset.pause;
          this.motionButton.querySelector('.wrc-route-hero__motion-mark').textContent = this.paused ? '▷' : 'Ⅱ';
          if (this.paused) {
            cancelAnimationFrame(this.frame);
            this.frame = 0;
          } else { this.schedule(); }
        }, { signal });
        this.observer = new IntersectionObserver(entries => {
          this.visible = entries.some(entry => entry.isIntersecting);
          if (this.visible) { this.schedule(); }
          else { cancelAnimationFrame(this.frame); this.frame = 0; }
        });
        this.observer.observe(this);
        this.configure();
      }
      render() {
        const rect = this.getBoundingClientRect();
        const distance = Math.max(1, this.offsetHeight - this.stage.offsetHeight);
        const progress = Math.max(0, Math.min(1, -rect.top / distance));
        this.style.setProperty('--wrc-progress', progress.toFixed(4));
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
        cancelAnimationFrame(this.frame);
        this.controller = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
